import { render, staticRenderFns } from "./heathAndSafety.vue?vue&type=template&id=26647f85"
import script from "./heathAndSafety.vue?vue&type=script&lang=js"
export * from "./heathAndSafety.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports